import { createAction } from '@reduxjs/toolkit';

import type { UpdateLLMSettingsPayload } from '@polyai/stream/commands/handlers/llm-settings';

import { LLM_SETTINGS_SLICE_NAME } from './constants';

export const updateLLMSettings = createAction<UpdateLLMSettingsPayload>(
  `${LLM_SETTINGS_SLICE_NAME}/updateLlmSettings`,
);
